import app from "./config/configApp";
import router from "./routes";
import store from "@/vuex/store";
import pinia from "./store";
import axios from "axios";
import { i18n } from "./i18n";
import UiLanguageSwitcher from "./components/UiLanguageSwitcher.vue";
import AudienceFilters from "./components/AudienceFilters.vue";
import { applyRequestContext, setAudienceRouteReader } from "./i18n/requestContext";
import { getItem } from "./utility/localStorageControl";
import "./static/css/style.css";
import "glightbox/dist/css/glightbox.min.css";
// Vue 3rd party plugins
import "@/core/plugins/ant-design";
import "@/core/plugins/fonts";
import "@/core/components/custom";
import "@/core/components/style";

setAudienceRouteReader(() => router.currentRoute.value.path);

axios.interceptors.request.use((config) => {
  applyRequestContext(config);
  const token = getItem("userAccessToken");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

app.config.productionTip = false;
app.use(i18n);
app.component("UiLanguageSwitcher", UiLanguageSwitcher);
app.component("AudienceFilters", AudienceFilters);
app.use(store);
app.use(pinia);
app.use(router);
app.mount("#app");
